
import { defineComponent, inject, computed } from 'vue';
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import moment from 'moment';
import BlogTag from '../components/BlogTag.vue'

export default defineComponent({
  name: 'BlotPost',
  inject: ['$C'],
  components: { BlogTag },
  setup() {
    const route = useRoute()
    const store = useStore()
    const postHeader = store.getters.getPostHeader(route.params.blogId)
    store.dispatch('fetchPost', { base: postHeader.base, blogId: route.params.blogId})
    const postContent = computed(() => {
      return store.getters.getPostContent(route.params.blogId)
    })
    const loading = computed(() => {
      return store.getters.getLoading()
    })
    const convertDate = (dt: string): string => {
      return moment(Date.parse(dt)).format('YYYY/MM/DD')
    }
    return {
      loading,
      postHeader,
      postContent,
      convertDate,
    }
  }
});
